module.exports = __webpack_public_path__ + "static/guide_bg.c19dd7aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/guide_bg.jpg
// module id = 3120
// module chunks = 226605119891641